


    <form autocomplete="off" novalidate>
        <div class="card-body">
            <div class="col-sm-12 text-center">
                <div class=" d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/images/online-payment.png"
                        class="mh-45px pb-2 logosz">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Payment Gateway
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            List of Payment Gateway Options
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="row mt-2 justify-content-center">
                    <div class="col-sm-3 d-flex justify-content-center" *ngFor="let gateway of paymentGatewayList">
                        <div class="card css1">
                            <div class="card-content hoverrrr" (click)="redirect(gateway)">
                              <h6 class="m-2 p-3 w7 main-content-label">{{gateway.gatewayName}}</h6>
                            </div>
                          </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <button type="button" class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1 fr"
                        (click)="close()">
                        <span style="display: contents; align-items: center;">
                            <img width="20vh"  src="../../assets/img/turn-left.gif" style="margin-right: 5px;">
                            Back
                        </span>
                    </button>
                </div>
            </div>
            
        </div>
    </form>

    
